var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAddCircleOutline(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2559_1619)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.0711 4.92893C15.182 1.03984 8.81802 1.03984 4.92893 4.92893C1.03985 8.81802 1.03985 15.182 4.92893 19.0711C8.81802 22.9602 15.182 22.9602 19.0711 19.0711C22.9602 15.182 22.9602 8.81802 19.0711 4.92893ZM5.98959 18.0104C2.66619 14.687 2.66619 9.31299 5.98959 5.98959C9.31299 2.66619 14.687 2.66619 18.0104 5.98959C21.3338 9.31299 21.3338 14.687 18.0104 18.0104C14.687 21.3338 9.31299 21.3338 5.98959 18.0104ZM17.0205 12.7778H12.7778V17.0205C12.7778 17.4447 12.4243 17.7983 12 17.7983C11.8586 17.7983 11.6464 17.7276 11.505 17.5861C11.3636 17.4447 11.2929 17.2326 11.2929 17.0912V12.8485H7.05025C6.90883 12.8485 6.6967 12.7778 6.55528 12.6364C6.41386 12.495 6.27243 12.2121 6.27243 12.0707C6.27243 11.6464 6.62599 11.2929 7.05025 11.2929H11.2929V7.05025C11.2929 6.62599 11.6464 6.27243 12.0707 6.27243C12.495 6.27243 12.8485 6.62599 12.8485 7.05025L12.8485 11.2929L17.0912 11.2929C17.5154 11.2929 17.869 11.6464 17.869 12.0707C17.869 12.495 17.4447 12.7778 17.0205 12.7778Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2559_1619"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddCircleOutline);
export default __webpack_public_path__ + "static/media/add_circle_outline.6f864333.svg";
export { ForwardRef as ReactComponent };